<template>

    <svg v-if="hollow" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 12.9996L8.95 15.9506C9.13855 16.2323 9.45158 16.4055 9.79037 16.4156C10.1292 16.4257 10.452 16.2716 10.657 16.0017L16.75 7.99951" stroke="#27AE60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.25 23.5C18.4632 23.5 23.5 18.4632 23.5 12.25C23.5 6.0368 18.4632 1 12.25 1C6.0368 1 1 6.0368 1 12.25C1 18.4632 6.0368 23.5 12.25 23.5Z" stroke="#27AE60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg v-else width="70"
         height="70"
         viewBox="0 0 70 70"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z" fill="#2CA95E"/>
        <path d="M17.5 36.2961L28.5185 47.3146L50.5556 25.2776"
              stroke="white"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"/>
    </svg>

</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Checkmark',
        props: {
            hollow: { type: Boolean, default: false }
        }
    })
</script>
